export const queryKeys = {
  auth: {
    profile: () => ['auth', 'profile'] as const,
  },
  projects: {
    all: (orgId: string) => ['projects', orgId] as const,
    detail: (orgId: string, id: string) => ['projects', orgId, id] as const,
  },
  boqs: {
    all: (orgId: string) => ['boqs', orgId] as const,
    items: (boqId: string) => ['boqs', 'items', boqId] as const,
  },
  users: {
    all: (orgId: string) => ['users', orgId] as const,
  },
  bids: {
    all: (orgId: string) => ['bids', orgId] as const,
    detail: (orgId: string, id: string) => ['bids', orgId, id] as const,
  },
  estimates: {
    all: (orgId: string) => ['estimates', orgId] as const,
    items: (estimateId: string) => ['estimates', 'items', estimateId] as const,
  },
  budgets: {
    all: (orgId: string) => ['budgets', orgId] as const,
    byProject: (orgId: string, projectId: string) => ['budgets', orgId, projectId] as const,
    projectSummary: (projectId: string) => ['budgets', 'project-summary', projectId] as const,
    changeOrders: (orgId: string, projectId: string) => ['budget-change-orders', orgId, projectId] as const,
    changeOrdersByBudget: (budgetId: string) => ['budget-change-orders', 'by-budget', budgetId] as const,
  },
  purchaseOrders: {
    all: (orgId: string) => ['purchase-orders', orgId] as const,
  },
  contracts: {
    all: (orgId: string) => ['contracts', orgId] as const,
  },
  schedules: {
    all: (orgId: string) => ['schedules', orgId] as const,
    tasks: (scheduleId: string) => ['schedules', 'tasks', scheduleId] as const,
  },
  dailyLogs: {
    all: (orgId: string) => ['daily-logs', orgId] as const,
  },
  changeOrders: {
    all: (orgId: string) => ['change-orders', orgId] as const,
  },
  apInvoices: {
    all: (orgId: string) => ['ap-invoices', orgId] as const,
  },
  paymentApps: {
    all: (orgId: string) => ['payment-apps', orgId] as const,
  },
  payments: {
    all: (orgId: string) => ['payments', orgId] as const,
  },
  costCodes: {
    all: (orgId: string) => ['cost-codes', orgId] as const,
  },
  timesheets: {
    all: (orgId: string) => ['timesheets', orgId] as const,
    entries: (timesheetId: string) => ['timesheets', 'entries', timesheetId] as const,
  },
  audit: {
    activity: (orgId: string) => ['audit', 'activity', orgId] as const,
  },
  inventoryItems: {
    all: (orgId: string) => ['inventory-items', orgId] as const,
  },
  warehouses: {
    all: (orgId: string) => ['warehouses', orgId] as const,
    enums: () => ['warehouses', 'enums'] as const,
  },
  projectLocations: {
    all: (projectId: string) => ['project-locations', projectId] as const,
  },
  projectTeam: {
    all: (projectId: string) => ['project-team', projectId] as const,
  },
  requisitions: {
    all: (orgId: string) => ['requisitions', orgId] as const,
    items: (reqId: string) => ['requisitions', 'items', reqId] as const,
  },
  notifications: {
    inbox: (userId: string) => ['notifications', 'inbox', userId] as const,
  },
  saas: {
    orgs: () => ['saas', 'orgs'] as const,
    org: (id: string) => ['saas', 'orgs', id] as const,
    orgUsers: (id: string) => ['saas', 'orgs', id, 'users'] as const,
    registrations: () => ['saas', 'registrations'] as const,
    users: () => ['saas', 'users'] as const,
    licenses: () => ['saas', 'licenses'] as const,
    audit: () => ['saas', 'audit'] as const,
    dashboard: () => ['saas', 'dashboard'] as const,
  },
};
